var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 19,
    viewBox: "0 0 35 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Locations/Stand-Alone/No-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Locations/Stand-Alone/No-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.00012207H34.565V18.7241H0V0.00012207Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9756 9.32712C30.7186 9.36912 30.5196 9.58312 30.5196 9.85212C30.5196 10.1221 30.7186 10.3351 30.9756 10.3781V12.9431C30.7186 12.9851 30.5196 13.1991 30.5196 13.4691C30.5196 13.7381 30.7186 13.9521 30.9756 13.9941V16.5591C30.7186 16.6011 30.5196 16.8151 30.5196 17.0851C30.5196 17.1341 30.5356 17.1791 30.5476 17.2241H27.6716C27.6846 17.1791 27.7006 17.1341 27.7006 17.0851C27.7006 16.7851 27.4576 16.5421 27.1596 16.5421C27.0436 16.5421 26.9416 16.5871 26.8536 16.6491V13.9031C26.9416 13.9661 27.0436 14.0111 27.1596 14.0111C27.4576 14.0111 27.7006 13.7681 27.7006 13.4691C27.7006 13.1691 27.4576 12.9261 27.1596 12.9261C27.0436 12.9261 26.9416 12.9711 26.8536 13.0341V10.2871C26.9416 10.3501 27.0436 10.3941 27.1596 10.3941C27.4576 10.3941 27.7006 10.1521 27.7006 9.85212C27.7006 9.55312 27.4576 9.31012 27.1596 9.31012C27.0436 9.31012 26.9416 9.35512 26.8536 9.41712V9.01312H30.9756V9.32712ZM25.3536 17.2241H22.3096V7.51312H12.2546V17.2241H9.23063V7.51312V4.80212H25.3536V7.51312V17.2241ZM18.0326 17.2241H20.8096V9.01312H18.0326V17.2241ZM13.7546 17.2241H16.5316V9.01312H13.7546V17.2241ZM7.73063 9.01312V9.31512C7.72063 9.31512 7.71263 9.31012 7.70363 9.31012C7.40563 9.31012 7.16363 9.55312 7.16363 9.85212C7.16363 10.1521 7.40563 10.3941 7.70363 10.3941C7.71263 10.3941 7.72063 10.3891 7.73063 10.3891V12.9311C7.72063 12.9311 7.71263 12.9261 7.70363 12.9261C7.40563 12.9261 7.16363 13.1691 7.16363 13.4691C7.16363 13.7681 7.40563 14.0111 7.70363 14.0111C7.71263 14.0111 7.72063 14.0061 7.73063 14.0051V16.5481C7.72063 16.5471 7.71263 16.5421 7.70363 16.5421C7.40563 16.5421 7.16363 16.7851 7.16363 17.0851C7.16363 17.1341 7.17863 17.1791 7.19063 17.2241H4.31563C4.32863 17.1791 4.34363 17.1341 4.34363 17.0851C4.34363 16.7851 4.10163 16.5421 3.80263 16.5421C3.73363 16.5421 3.66863 16.5581 3.60863 16.5821V13.9721C3.66863 13.9951 3.73363 14.0111 3.80263 14.0111C4.10163 14.0111 4.34363 13.7681 4.34363 13.4691C4.34363 13.1691 4.10163 12.9261 3.80263 12.9261C3.73363 12.9261 3.66863 12.9421 3.60863 12.9661V10.3551C3.66863 10.3791 3.73363 10.3941 3.80263 10.3941C4.10163 10.3941 4.34363 10.1521 4.34363 9.85212C4.34363 9.55312 4.10163 9.31012 3.80263 9.31012C3.73363 9.31012 3.66863 9.32612 3.60863 9.34912V9.01312H7.73063ZM11.3196 3.30212H23.2646V1.50012H11.3196V3.30212ZM33.8156 7.51312H32.4756H26.8536V3.30212H24.7646V1.50012H26.1036C26.5176 1.50012 26.8536 1.16412 26.8536 0.750122C26.8536 0.336122 26.5176 0.00012207 26.1036 0.00012207H24.7646H9.81963H8.48063C8.06663 0.00012207 7.73063 0.336122 7.73063 0.750122C7.73063 1.16412 8.06663 1.50012 8.48063 1.50012H9.81963V3.30212H7.73063V7.51312H2.10863H0.749634C0.335634 7.51312 -0.000366211 7.84912 -0.000366211 8.26312C-0.000366211 8.67712 0.335634 9.01312 0.749634 9.01312H2.10863V18.7241H7.73063H9.23063H12.2546H22.3096H25.3536H26.8536H32.4756V9.01312H33.8156C34.2296 9.01312 34.5656 8.67712 34.5656 8.26312C34.5656 7.84912 34.2296 7.51312 33.8156 7.51312Z",
    fill: "#5b6770"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72459 12.1982C6.02359 12.1982 6.26559 11.9552 6.26559 11.6562C6.26559 11.3562 6.02359 11.1132 5.72459 11.1132C5.42559 11.1132 5.18359 11.3562 5.18359 11.6562C5.18359 11.9552 5.42559 12.1982 5.72459 12.1982Z",
    fill: "#5b6770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.081 12.1982C29.38 12.1982 29.622 11.9552 29.622 11.6562C29.622 11.3562 29.38 11.1132 29.081 11.1132C28.782 11.1132 28.54 11.3562 28.54 11.6562C28.54 11.9552 28.782 12.1982 29.081 12.1982Z",
    fill: "#5b6770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72459 15.8144C6.02359 15.8144 6.26559 15.5714 6.26559 15.2724C6.26559 14.9724 6.02359 14.7294 5.72459 14.7294C5.42559 14.7294 5.18359 14.9724 5.18359 15.2724C5.18359 15.5714 5.42559 15.8144 5.72459 15.8144Z",
    fill: "#5b6770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.081 15.8144C29.38 15.8144 29.622 15.5714 29.622 15.2724C29.622 14.9724 29.38 14.7294 29.081 14.7294C28.782 14.7294 28.54 14.9724 28.54 15.2724C28.54 15.5714 28.782 15.8144 29.081 15.8144Z",
    fill: "#5b6770"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.a55ab8f8bee1c99f2571be84ea9aacbf.svg";
export { ForwardRef as ReactComponent };